import { useMemo } from "react";
import { PageHeader } from "@/shared/components/PageHeader";
import { useUrlTableState } from "@/shared/hooks/useUrlState";
import { type NotificationFilters, NotificationTable } from "../components/NotificationTable";

export function NotificationsPage() {
	const { page, limit, setPage, getFilter, setFilters } = useUrlTableState({ defaultLimit: 20 });

	const filters = useMemo<NotificationFilters>(
		() => ({
			type: getFilter("type") as NotificationFilters["type"],
			dateFrom: getFilter("dateFrom"),
			dateTo: getFilter("dateTo"),
		}),
		[getFilter]
	);

	const handleFiltersChange = (next: NotificationFilters) => {
		// Filter change + page reset in a single history entry.
		setFilters({
			type: next.type ?? null,
			dateFrom: next.dateFrom ?? null,
			dateTo: next.dateTo ?? null,
		});
	};

	return (
		<div>
			<PageHeader
				title="Bildirishnomalar"
				subtitle="Sizga yuborilgan bildirishnomalar tarixi (eng yangisi birinchi)"
			/>
			<NotificationTable
				page={page}
				limit={limit}
				onPageChange={setPage}
				filters={filters}
				onFiltersChange={handleFiltersChange}
			/>
		</div>
	);
}
